import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

function Unauthorized() {
	const { t } = useTranslation();
	return <Box>{t('system:titlesUnauthorized')}</Box>;
}

export default Unauthorized;
